import TypographyPoppins from "@/components/Atoms/TypographyPoppins";

import React from "react";

const ProductsProgressBar = ({ viewed, total }) => {
    const percentage = Math.min((viewed / total) * 100, 100);

    return (
        <div className="w-full max-w-md mx-auto my-6 text-center">
            <TypographyPoppins
                fontWeight="normal"
                color={"Text_Gray"}
                text={`You have viewed ${viewed} of ${total} products`}
            />

            <div className="w-full h-2 bg-LIGHT_GRAY rounded-full overflow-hidden mt-5">
                <div
                    className="h-full bg-Primary_Default transition-all duration-300 ease-in-out"
                    style={{ width: `${percentage}%` }}
                />
            </div>
        </div>
    );
};

export default ProductsProgressBar;
